import { Box, Checkbox, FormField, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { WIX_APP_MARKET_TERMS_AND_CONDITIONS } from '../../../consts';
import { GeneralUserConsentLayout } from '../UserConsent';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useInstallerContext } from '../../../context/InstallerContext';
import css from '../UserConsent.scss';
import { getCompanyPrivacyPolicy } from '../../../selectors/companyInfo';
export const BlocksWithoutEnforcedPermissions = _ref => {
  let {
    shouldOpenNewWindow,
    onAgreeButtonClick,
    onCloseButtonClick
  } = _ref;
  const {
    preInstallationData: {
      app,
      companyInfo,
      isAppAlreadyInstalled
    }
  } = useInstallerContext();
  const {
    t
  } = useTranslation();
  const [isAgreeToTerms, setIsAgreeToTerms] = React.useState(false);
  const [error, setError] = React.useState(null);
  const privacyPolicyUrl = getCompanyPrivacyPolicy(companyInfo);
  const PrivacyPolicyLink = _ref2 => {
    let {
      children
    } = _ref2;
    return privacyPolicyUrl ? /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      underline: "always",
      onClick: () => {
        window.open(privacyPolicyUrl);
      }
    }, children) : /*#__PURE__*/React.createElement("span", null, children);
  };
  return /*#__PURE__*/React.createElement(GeneralUserConsentLayout, {
    shouldOpenNewWindow: shouldOpenNewWindow,
    titleText: t('user-consent.blocks-without-enforced-permissions.title', {
      appName: app == null ? void 0 : app.name,
      isAppAlreadyInstalled
    }),
    onCloseButtonClick: onCloseButtonClick,
    onAgreeButtonClick: () => {
      if (isAgreeToTerms) {
        onAgreeButtonClick();
      } else {
        setError(t('user-consent.blocks-without-enforced-permissions.error'));
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: css.modalContentWrapper
  }, /*#__PURE__*/React.createElement(Box, {
    dataHook: "blocks-without-enforced-permissions-content",
    display: "block",
    overflow: "scroll",
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Text, {
    listStyle: "circle",
    size: "small"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t('user-consent.blocks-without-enforced-permissions.section1')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("li", null, t('user-consent.blocks-without-enforced-permissions.section2')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    values: {
      appName: app == null ? void 0 : app.name
    },
    i18nKey: "user-consent.blocks-without-enforced-permissions.section3"
  }, /*#__PURE__*/React.createElement(PrivacyPolicyLink, null))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    values: {
      isAppAlreadyInstalled
    },
    i18nKey: "user-consent.blocks-without-enforced-permissions.section4"
  }, /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    underline: "always",
    onClick: () => window.open(WIX_APP_MARKET_TERMS_AND_CONDITIONS)
  })))))), /*#__PURE__*/React.createElement(BlocksCheckbox, {
    isChecked: isAgreeToTerms,
    setError: setError,
    setIsChecked: setIsAgreeToTerms,
    error: error
  })));
};
const BlocksCheckbox = _ref3 => {
  let {
    error,
    isChecked,
    setIsChecked,
    setError
  } = _ref3;
  const {
    t
  } = useTranslation();
  const {
    preInstallationData: {
      isAppAlreadyInstalled
    }
  } = useInstallerContext();
  return /*#__PURE__*/React.createElement(Box, {
    marginTop: "6px",
    paddingTop: "6px"
  }, /*#__PURE__*/React.createElement(FormField, {
    required: true,
    stretchContent: false,
    status: error ? 'error' : undefined,
    statusMessage: error || null
  }, /*#__PURE__*/React.createElement(Checkbox, {
    dataHook: "checkbox-to-agree-to-add-blocks-dashboard",
    size: "small",
    checked: isChecked,
    onChange: () => {
      setIsChecked(prev => !prev);
      setError(null);
    }
  }, t('user-consent.blocks-without-enforced-permissions.checkbox-text', {
    isAppAlreadyInstalled
  }))));
};
//# sourceMappingURL=BlocksWithoutEnforcedPermissions.js.map